
<a-layout>
  <drawer v-if="isMobile" :openDrawer="mobileMenuOpen" :showHandler="false" @change="onDrawerChange">
    <sider-menu :theme="theme" :menuData="menuData" :collapsed="false" :collapsible="false" @menuSelect="onMenuSelect"/>
  </drawer>
  <sider-menu :theme="theme" v-else-if="layout === 'side'" :menuData="menuData" :collapsed="collapsed" :collapsible="true" />
  <drawer :openDrawer="settingBar" placement="right" :showHandler="false" @change="setSettingBar">
    <setting/>
  </drawer>
  <a-layout :style="{ paddingLeft: paddingLeft }">
    <global-header :menuData="menuData" :collapsed="isMobile ? !mobileMenuOpen : collapsed" @toggleCollapse="toggleCollapse" @menuSelect="onMenuSelect"/>
    <a-layout-content :style="{minHeight: minHeight, margin: '20px 14px 0'}" :class="fixHeader ? 'fixed-header-content' : null">
      <slot></slot>
    </a-layout-content>
    <a-layout-footer style="padding: .29rem 0" class="copyright">
      <global-footer :copyright="copyright"/>
    </a-layout-footer>
  </a-layout>
</a-layout>
